<div class="intervention-modal-backdrop" (click)="fermerSurBackdrop($event)">
  <article
    class="intervention-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="intervention-modal-title"
    [cdkTrapFocus]="!editionEnCours()"
    [cdkTrapFocusAutoCapture]="true"
  >
    <header class="intervention-modal-header">
      <div>
        @if (data().eyebrow) {
          <p>{{ data().eyebrow }}</p>
        }
        <h2 id="intervention-modal-title" tabindex="-1" cdkFocusInitial>{{ data().title }}</h2>
      </div>
      <button
        type="button"
        class="intervention-modal-close"
        aria-label="Fermer"
        (click)="fermer.emit()"
      >
        <span class="material-symbols-outlined">close</span>
      </button>
    </header>

    <div class="intervention-modal-grid">
      @for (information of data().informations; track information.label) {
        <div class="intervention-modal-information">
          @if (information.icon) {
            <span class="material-symbols-outlined intervention-modal-information-icon">{{
              information.icon
            }}</span>
          }
          <div>
            <span>{{ information.label }}</span>
            <strong>{{ information.value }}</strong>
          </div>
        </div>
      }
    </div>

    <section class="intervention-modal-details">
      <h3>{{ data().detailsLabel }}</h3>
      <p>{{ data().details }}</p>
    </section>

    @if (chargement()) {
      <p role="status">Chargement des détails de l’intervention…</p>
    } @else if (erreur()) {
      <p role="alert">{{ erreur() }}</p>
      <button type="button" class="intervention-modal-reessayer" (click)="reessayer()">
        Réessayer
      </button>
    } @else if (consultation(); as detail) {
      <app-intervention-photos [photos]="detail.photos" />
      <div class="intervention-modal-actions">
        @if (planificationEditable(); as edition) {
          <app-intervention-acces [edition]="edition" (ouverture)="suivreEdition($event)" />
        }
        @if (detail.suppression; as edition) {
          <app-intervention-suppression [edition]="edition" (ouverture)="suivreEdition($event)" />
        }
      </div>
    }

    @if (data().ticketLink; as lien) {
      <a class="intervention-modal-ticket-link" [routerLink]="lien" (click)="fermer.emit()">
        <span class="material-symbols-outlined">confirmation_number</span>
        <span>{{ data().ticketLabel }}</span>
      </a>
    }
  </article>
</div>
